import "scripts/templates/page.how-to.js";
import { registerBundle } from "scripts/lib/register-bundle.js";
registerBundle("template.page.how-to");
